import React from 'react';
import { useStandupStore } from '../../controllers/store';
import { EndStandupButton } from './end-standup-button';
import { StartStandupButton } from './start-standup-button';

export const StandupControlButtons = () => {
	const [{ isActive }] = useStandupStore();

	return isActive ? <EndStandupButton /> : <StartStandupButton />;
};
